// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/user-plus.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'user-plus',
  version: 'outline',
  paths: [
    {
      d: 'M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2',
      paint: 'fill',
    },
    {
      d: 'M8.5 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8',
      paint: 'fill',
    },
    {
      d: 'M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M20 8v6m3-3h-6m-4.5-4a4 4 0 1 1-8 0 4 4 0 0 1 8 0',
    },
  ],
}
